<div>
  <div matDialogTitle class="modal-title">Add to Request</div>
  <div class="layout-row-space-around-stretch">
    <div class="flex-column">
      <mat-radio-button [checked]="true" (click)="createNewRequest()">Create a new request</mat-radio-button>
      <mat-radio-button [checked]="false" (click)="addToExistingRequest()">Add to existing request
      </mat-radio-button>
    </div>
    <p class="info-text">{{assetIds.length}} asset{{assetIds.length > 1 ? 's' : ''}} will be added to
      {{isNewRequest ? 'a new' : 'an existing'}}
      request
    </p>
  </div>
  <form #requestForm="ngForm" class="layout-column-space-around-stretch request-form">
    @if (isNewRequest) {
      <p class="info-text">A request number will be auto-generated once this request is created.
      </p>
    }
    <div class="space-between-form">
      @if (isNewRequest) {
        <div>
          <mat-form-field class="name-field">
            <mat-label>Request Name</mat-label>
            <input matInput value="" [(ngModel)]="request.name" maxlength="255"
              name="name" pattern=".*\S.*">
            </mat-form-field>
          </div>
        }
        @if (!isNewRequest) {
          <div>
            <span matTooltip="You have no existing requests"
              [matTooltipDisabled]="(requestOptions$ | async).length > 0">
              <p-select appendTo="body" mat-raised-button [options]="requestOptions$ | async"
                placeholder="Existing Requests" (onChange)="selectExistingRequest($event)"
                [disabled]="!(requestOptions$ | async).length"
                [filter]="!(deviceService.isMobile() || deviceService.isTablet())"
                [virtualScroll]="true" [virtualScrollItemSize]="30">
              </p-select>
            </span>
          </div>
        }
        <div>
          <mat-form-field>
            <mat-label>Need Response By</mat-label>
            <input matInput [matDatepicker]="picker" readonly (click)="picker.open()" name="deadline" [(ngModel)]="deadline">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            @if (deadline) {
              <mat-datepicker-toggle matSuffix (click)="removeDate()">
                <mat-icon matDatepickerToggleIcon>cancel</mat-icon>
              </mat-datepicker-toggle>
            }
            <mat-datepicker [touchUi]="deviceService.isMobile() || deviceService.isTablet()" #picker></mat-datepicker>
            <mat-error>A valid date is required</mat-error>
          </mat-form-field>
        </div>
      </div>
      <mat-form-field class="flex-size-20 wk-flex-fix">
        <mat-label>Note to Approver</mat-label>
        <textarea matInput value="" [(ngModel)]="requestNote.note" maxlength="1000"
        name="note" required></textarea>
      </mat-form-field>
    </form>
    <p class="info-text">
      @if (!isSendRequest) {
        <span> Your request will not be sent when you press "Add" - you can continue to add assets to this request before
        sending it for approval.</span>
      }
    </p>
    @if (isNewRequest) {
      <div>
        <mat-checkbox class="row-checkbox"
          (change)="onChange($event)"
          [(ngModel)]="isSendRequest"
          matTooltip="Send request immediately">Send request immediately
        </mat-checkbox>
      </div>
    }
  
    <div>
     @for (item of savingMessage; track item) {
      <p-message [severity]="item.severity">{{item.summary}}</p-message>
    }
    </div>
        
  
    
    <div class="flex justify-flex-end center gap-20">
      <button mat-raised-button matDialogClose class="flex-20" [disabled]="saveDisabled">Cancel</button>
      <button mat-raised-button color="primary" (click)="save()" class="flex-20" [disabled]="saveDisabled || (requestNote && requestNote.note && requestNote.note.length === 0) || (!isNewRequest && !request.id) || !requestForm.form.valid">
        @if (!isSendRequest) {
          <label>Add</label>
        }
        @if (isSendRequest) {
          <label>Send</label>
        }
      </button>
    </div>
  </div>
